import React, { useState, useEffect } from 'react';
import SubmenuList from './SubmenuList';
import HowToUse from './HowToUse';
import Howtousenew from './Howtousenew';
import FooterControl from './FooterControls';
import ColorWrapper from './ColorWrapper';
import ReactDOM from 'react-dom';
const Menu = () => {
   const [myJson, setMyJson] = useState([]);
   const [menuList, setMenuList] = useState([]);
   

   const [buttonArray, setbuttonArray] = useState([]);
   const [buttonArrayObjectList, setbuttonArrayObjectList] = useState([]);
   const [uiDataList, setuiDataList] = useState({});
   const [productTitle, setProductTitle] = useState([]);

// var onOffBacklit = true;
var ScreenAnimInterval2;
var onOffkeyBoBacklit = false;

var rigntAnim;
var rightAnimToggle = false;
var picker,isipad_,r,g,b;


var onOffBacklit = false;
var setOnOffBacklit = false;


   let howtoUseD = false;
   var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);
   var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

   const getData = () => {
      fetch('data.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      )
         .then(function (response) {
            return response.json();
         })
         .then(function (mydata) {
            return mydata;

         }).then(function (setmydata) {
            setMyJson(setmydata);

            document.title = setmydata.ProjectTitle;
            window.ProjectTitle = setmydata.ProjectTitle;
            let feature_list;
            let menuData;
            let uiData;

            if (setmydata.menus[window.LangName] == undefined) {
               uiData = setmydata.menus.EN[0];
            } else {
               uiData = setmydata.menus[window.LangName][0];
            }
            window.dataUI = uiData;
            // console.log("++++",uiData.ui)
            if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {
               menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
            }
            else {
               // console.warn("Language Not Found setting default language.")
               menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')
               // selectedMenu= menuData;
               var mobProducts = menuData[0].items;
               // console.log(menuData)
            }
            setMenuList(menuData);
            setuiDataList(uiData);
            //console.log("-----",uiDataList);
            setProductTitle(mobProducts);
            // completeData =menuData;

            setbuttonArray([]);
            setbuttonArrayObjectList([])
            langTranslationAlignment(menuData);
            menuData.map((menu) => {
               menu.items.map(item => {
                  setbuttonArray((buttonArray) => [...buttonArray, item.id]);
                  setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);
               })
            })
         });
   }
   const langTranslationAlignment = (menuData) => {
      // console.log(window.dataUI.ui.langcode);
      // console.log(menuData)
      if (window.dataUI) {
         document.querySelector('title').innerHTML = window.dataUI.ui.projectTitle;
         document.getElementById('move_text').innerHTML = window.dataUI.ui.move;
         document.getElementById('rotate_text').innerHTML = window.dataUI.ui.rotate;
         document.getElementById('zoom_text').innerHTML = window.dataUI.ui.zoom;
         document.getElementById('exploreButtton').innerHTML = window.dataUI.ui.exploreProductIn3D;
         if (mob && window.innerHeight > window.innerWidth) {
            // console.log("Mob portrait")
            if (window.dataUI.ui.langcode.toLowerCase() === "no" || window.dataUI.ui.langcode.toLowerCase() === "nl"
               || window.dataUI.ui.langcode.toLowerCase() === "de" ) {
               setTimeout(() => {
                  var nodeList = document.querySelectorAll('.menu .text');
                  for (var i = 0; i < nodeList.length; i++) {
                     nodeList[i].style.fontSize = '9px';
                     nodeList[i].style.paddingRight = '10px';
                  }
               }, 100);
               setTimeout(() => {
                  var nodeListSubMenu = document.querySelectorAll('.accordionContent ul.subMenu .subMenuBtn');
                  for (var i = 0; i < nodeListSubMenu.length; i++) {
                     nodeListSubMenu[i].style.fontSize = '10px';
                  }
               }, 100)
            }
            if (window.dataUI.ui.langcode == "sv") {
               setTimeout(() => {
                  var nodeList = document.querySelectorAll('.menu .text');
                  for (var i = 0; i < nodeList.length; i++) {
                     nodeList[i].style.fontSize = '9px';
                     nodeList[i].style.paddingRight = '8px';
                  }
               }, 100);

               setTimeout(() => {
                  var nodeListSubMenu = document.querySelectorAll('.accordionContent ul.subMenu .subMenuBtn');
                  for (var i = 0; i < nodeListSubMenu.length; i++) {
                     nodeListSubMenu[i].style.fontSize = '10px';
                  }
               }, 100);
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "pl") {
               document.querySelector("#mobHowToUseText").style.top = '-16%';
               document.querySelector("#move_text").style.fontSize = "32px";
               document.querySelector("#rotate_text").style.fontSize = "32px";
               document.querySelector("#zoom_text").style.fontSize = "32px";
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "nl") {
               document.querySelector(".portraitButtonText").style.fontSize = '11.5px';
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "nl") {
               document.querySelector(".portraitButtonText").style.fontSize = '11.5px';
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "fr-ca" || window.dataUI.ui.langcode.toLowerCase() === "fr") {
               document.querySelector("#move_text").style.fontSize = "37px";
               document.querySelector("#rotate_text").style.fontSize = "37px";
               document.querySelector("#zoom_text").style.fontSize = "37px";
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "it" || window.dataUI.ui.langcode.toLowerCase() === "fr-ca" || window.dataUI.ui.langcode.toLowerCase() === "fr"
               || window.dataUI.ui.langcode.toLowerCase() === "es" || window.dataUI.ui.langcode.toLowerCase() === "de") {
               document.querySelector("#move").style.alignItems = "center";
               document.querySelector("#rotate").style.alignItems = "center";
               document.querySelector("#zoom").style.alignItems = "center";

               document.querySelector("#move_text").style.marginRight = "60px";
               document.querySelector("#rotate_text").style.marginRight = "60px";
               document.querySelector("#zoom_text").style.marginRight = "60px";
            }
         } else if (window.isipad && window.innerHeight < window.innerWidth) {
            console.log("ipad landscape")
            if (window.dataUI.ui.langcode == "fr" || window.dataUI.ui.langcode == "fr-ca") {
               document.querySelector("#move_text").style.fontSize = "37px";
               document.querySelector("#rotate_text").style.fontSize = "37px";
               document.querySelector("#zoom_text").style.fontSize = "37px";
               document.getElementById("loading").style.width = '58%';
               document.querySelector("#animation span").style.fontSize = "14px";
               setTimeout(() => {
                  var nodeList = document.querySelectorAll('.menu .text');
                  for (var i = 0; i < nodeList.length; i++) {
                     nodeList[i].style.fontSize = '14px';
                  }
               }, 100);


               setTimeout(() => {
                  var nodeListSubMenu = document.querySelectorAll('.accordionContent ul.subMenu .subMenuBtn');
                  for (var i = 0; i < nodeListSubMenu.length; i++) {
                     nodeListSubMenu[i].style.fontSize = '14px';
                  }
               }, 100);
            }

            if (window.dataUI.ui.langcode == "nl") {
               document.querySelector("#move img").style.width = "200px";
               document.querySelector("#rotate img").style.width = "200px";
               document.querySelector("#zoom img").style.width = "200px";
            }
         }
         else {
            // console.log("Desktop")
            if (window.dataUI.ui.langcode == "de") {
               document.querySelector("#howToUSE span").style.left = '45px';
            }
            if (window.dataUI.ui.langcode == "de" || window.dataUI.ui.langcode == "es" || window.dataUI.ui.langcode == "nl") {
               document.querySelector("#move img").style.width = "200px";
               document.querySelector("#rotate img").style.width = "200px";
               document.querySelector("#zoom img").style.width = "200px";
            }
            if (window.dataUI.ui.langcode == "fr" || window.dataUI.ui.langcode == "fr-ca") {
               document.getElementById("loading").style.width = '58%';
               document.querySelector("#animation span").style.fontSize = "14px";
               setTimeout(() => {
                  var nodeList = document.querySelectorAll('.menu .text');
                  for (var i = 0; i < nodeList.length; i++) {
                     nodeList[i].style.fontSize = '14px';
                  }
               }, 100);


               setTimeout(() => {
                  var nodeListSubMenu = document.querySelectorAll('.accordionContent ul.subMenu .subMenuBtn');
                  for (var i = 0; i < nodeListSubMenu.length; i++) {
                     nodeListSubMenu[i].style.fontSize = '14px';
                  }
               }, 100);
            }
            if (window.dataUI.ui.langcode == "it") {

               var nodeList = document.querySelectorAll('.menu .text');
               for (var i = 0; i < nodeList.length; i++) {
                  nodeList[i].style.fontSize = '14px';
               }

               setTimeout(() => {
                  var nodeListSubMenu = document.querySelectorAll('.accordionContent ul.subMenu .subMenuBtn');
                  for (var i = 0; i < nodeListSubMenu.length; i++) {
                     nodeListSubMenu[i].style.fontSize = '14px';
                  }
               }, 100);
               document.querySelector("#move img").style.width = "225px";
               document.querySelector("#rotate img").style.width = "225px";
               document.querySelector("#zoom img").style.width = "225px";
               document.querySelector("#animation span").style.fontSize = "14px";
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "ja" || window.dataUI.ui.langcode.toLowerCase() === "pl") {
               document.querySelector(".tooltiptext").style.top = '-19px';
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "de") {
               document.querySelector(".tooltiptext").style.top = '-26px';
            }
            
         }
      }
   }

   useEffect(() => {
      const menuref = document.querySelector('.menuContainer');
      window.mainMenuRef = menuref;
   })

   useEffect(() => {
      setTimeout(() => {
         getData();
      }, 1000);
   }, [])

   window.checkWindowSize = function () {
   }

   const menuExpandCollaps = () => {
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      } else {
         mainMenu.classList.add('collapsed');
         mainMenu.classList.remove('expanded');
         var getExpandedAccordion = document.querySelectorAll('.menu.active');
         if (getExpandedAccordion.length !== 0) {
            for (var i = 0; i <= getExpandedAccordion.length; i++) {
               if (getExpandedAccordion[i] !== undefined) {
                  getExpandedAccordion[i].classList.remove('active');
                  getExpandedAccordion[i].nextSibling.style.height = '0px';
               }
            }
         }
      }
   }

   const howToUSEClick = (e) => {
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      document.querySelector('#howToUSE').focus();
         if (howtoUseD) {
          childrenWithTabIndex.forEach(child => {
          child.setAttribute('tabindex', '-1');
         });

         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#410290";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      } else {
     childrenWithTabIndex.forEach(child => {
        child.setAttribute('tabindex', '1');
     });
         // console.log("else.......")
         document.getElementById('howToUSE').style.opacity = "1";
         if (window.isipad && window.innerWidth > window.innerHeight) {
            document.getElementById('howToUSE').style.marginTop = "2.7%";
         } else {
            document.getElementById('howToUSE').style.marginTop = "-1%";
         }
         document.getElementById('howToUSE').style.animationName = "example1";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#410290";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#FFFFFF";
         document.getElementById('howToUseMenu').firstChild.classList.add('active');
         howtoUseD = true;
      }
   }

   const closeHandleMenu = (event) => {
      //TabIndex Click Functionality
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
          childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
        });
      document.querySelector('#howToUseMenu').focus();
      document.getElementById('howToUSE').style.opacity = "0";
      document.getElementById('howToUSE').style.marginTop = "-100%";
      document.getElementById('howToUSE').style.animationName = "example";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
      document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#410290";
      document.getElementById('howToUseMenu').firstChild.classList.remove('active');


      howtoUseD = false;
      }
   };


   const closeHandle = (event) => {
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#410290";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');
         howtoUseD = false;
      }
   };

   const accordionMenu = (e) => {
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn[tabIndex='1']");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];
      // console.log('subMenuTabIndex1Arr', subMenuTabIndex1Arr);
      subMenuTabIndex1Arr.forEach(ele =>{
         ele.setAttribute("tabIndex", "-1");
      });
      window.hidePopUp();
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      //   menu camera angle function call
      window.menu_all(myJson.menus.EN, e);
      setTimeout(function () {
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
      }, 500)

      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      }

      if (e.target.closest('.menu').classList.contains('active')) {
         if ((!window.mob && window.innerWidth > window.innerHeight)) {
            e.target.closest('.menu').classList.remove('active');
            e.target.closest('.menu').nextSibling.style.height = '0px';
         }
      }
      else {
         var menu_active = document.querySelectorAll('.menu');
         for (var i = 0; i <= menu_active.length - 1; i++) {
            if (menu_active[i].id !== 'howToUseMenu') {
               menu_active[i].classList.remove('active')
               menu_active[i].nextSibling.style.height = '0px';
            }
         }
         e.target.closest('.menu').classList.add('active');
         window.selectedButtonType = e.target.closest('.menu').id;
         var accordionContent = e.target.closest('.menu').nextSibling.firstChild;
         if (accordionContent != null) {
            e.target.closest('.menu').nextSibling.style.height = accordionContent.offsetHeight + 'px';
         }
         let currentTargetAccordion = e.target.closest('.menu.active')
         let currentTargetAccordionSubMenu = currentTargetAccordion.nextSibling;
         let subMenuElement = currentTargetAccordionSubMenu.querySelectorAll('.subMenuBtn');
         let subMenuElementArr = [...subMenuElement];
         console.log('currentTargetAccordionSubMenu', currentTargetAccordionSubMenu);
         console.log('subMenuElement', subMenuElement);
         subMenuElementArr.forEach(ele => {
            ele.setAttribute("tabIndex", "1");
         });
      }

      if (orentation === 90) {
         closeHandle();
      }

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }

   const subMenu = (e) => {
      // console.log("subMenu");
      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         selectedSubMenu[i].classList.remove('active')
      }
      e.target.classList.add('active');
   }

   var data1 = {
      method: accordionMenu,
      method2: howToUSEClick,
      method3: subMenu,
   }

   const handleTransitions = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;
      if (isChecked === true) {
         window.Animation = 'on';
      } else {
         window.Animation = 'off';
      }
   }

   const handleTransitionskeyPress = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;
      // console.log(isChecked)
      if (isChecked === true) {
         window.Animation = 'off';
         document.getElementById("animSwitchValue").checked = false;
      } else {
         window.Animation = 'on';
         document.getElementById("animSwitchValue").checked = true;
      }
   }
   var animStopped = true;

   const conScreenControlHandler = (e) => {
      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === true) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';
         if (window.mob && !window.isipad) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            if (window.innerWidth > window.innerHeight) {
               document.getElementById('footerControls').style.display = 'block';
               document.getElementById('footerControls').style.bottom = "55px";
            } else {
               document.getElementById('footerControls').style.display = 'none';
            }
         } else {
            // console.log("show");
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "1");
            }
            document.getElementById('footerControls').style.bottom = "55px";
         }
      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {
               animStopped = true;
            }, 200);
         }
      }
   }

   const conScreenControlHandlerkeyPress = (e) => {
      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === false) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         }
         else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            document.getElementById('footerControls').style.bottom = "55px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "1");
            }
            document.getElementById("onScreenControlsValue").checked = true;
         }
      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            document.getElementById("onScreenControlsValue").checked = false;
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {
               animStopped = true;
            }, 200);
         }
      }
   }

   // this function is used when we click on sub menu
   const handleMenuClick = (menu_object, e) => {
      // console.log("AnimComplated", window.AnimComplated);
      let cameraId = menu_object['id'];
      let cameraName = menu_object['cameraName'];
      let cameraType = menu_object['type'];
      if (!window.AnimComplated) {
         return
      }
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      window.currID = menu_object['id'];

      window.execute_all(menu_object);
      setMenuActive(cameraId, cameraType, e);

      window.prevID = menu_object['id'];
      if (orentation === 90) {
         closeHandle();
      }
   }

   // const handleAdditionalMenuClick = (menu_object, e) => {
   //    let cameraId = menu_object['id'];
   //    let cameraName = menu_object['cameraName'];
   //    let cameraType = menu_object['type'];
   //    let new_menu_object = [];
   //    if (!window.AnimComplated) {
   //       return
   //    }
     

   //    window.execute_all(new_menu_object);
   //    setMenuActive(cameraId, cameraType, e);
   //    window.hidePopUp();
   //    if (orentation === 90) {
   //       closeHandle();
   //    }
   // }

   // code for menu active
   const setMenuActive = (menu_id, menu_type, e) => {
      var currentActive;
      if (e != undefined) {
         currentActive = e.target.closest('li.list');
      } else {
         currentActive = document.getElementById('menu_id_' + menu_id);
      }
      let currentClass = currentActive.classList[0]
      let preActive = document.querySelector('.' + currentClass + '.active');

      if (preActive != null) {
        preActive.classList.remove('active');
     }
  
     if((window.mob || window.isipad) && window.innerHeight > window.innerWidth){
        if(preActive?.id == currentActive?.id){
           setTimeout(() => {
              currentActive.classList.remove('active')              
           }, 100);
        }else{
           currentActive.classList.add('active')
        }
     }else{        
        currentActive.classList.add('active');
     }
      window.selectedConfig.currentProductClick = currentActive.id;
      window.selectedButton = menu_id;
      window.checkedButton = menu_id;
      window.selectedButtonType = menu_type;
      window.updateSlider();
   }

   const onPreviousMode = () => {
      window.hidePopUp();
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      let cameraName;
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, window.Animation == 'on' ? 1000 : 100);
      }
      var prevButton;
      var selectedButtonIndex = buttonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton == 'onResetMode' || window.checkedButton == '') {
         prevButton = buttonArray[buttonArray.length - 1];
      } else {
         prevButton = buttonArray[selectedButtonIndex - 1];
      }

      if (prevButton == undefined) { prevButton = buttonArray[buttonArray.length - 1] }

      let result = buttonArrayObjectList.find(object => object.id == prevButton);
      window.currID = result['id'];
      if (window.selectedButtonType !== result['type']) {
         expandMenu(`accordion_${result['type']}`);
      }

      window.execute_all(result);
      setMenuActive(result['id'], result['type']);
      window.prevID = result["id"]
      return false;
   }

   const onNextMode = () => {
      window.hidePopUp();
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      let cameraName;
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, window.Animation == 'on' ? 1000 : 100);
      }
      var nextButton;
      var selectedButtonIndex = buttonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '') {
         nextButton = buttonArray[0];

      } else {
         nextButton = buttonArray[selectedButtonIndex + 1];
      }
      if (nextButton === undefined) { nextButton = buttonArray[0] }

      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      window.currID = result['id'];
      if (window.selectedButtonType !== result['type']) {
         expandMenu(`accordion_${result['type']}`);
      }
      window.execute_all(result);
      setMenuActive(result['id'], result['type']);
      window.prevID = result["id"]
      return false;
   }

   const onReset = () => {
      var slider = document.getElementById("sliderRange");
      let cameraName;
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      if (slider !== null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, window.Animation == 'on' ? 1000 : 100);
      }
      if (!window.AnimComplated) {
         return
      }
      let nextButton;
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '' || window.checkedButton === undefined) {
         window.GotoPosInTimeNamedValue(window.config.cameraReset);
      }
      else {
         nextButton = window.checkedButton;
      }
      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.checkedButton !== 'onResetMode' || window.checkedButton !== '') {
         if (result !== undefined) {
            expandMenu(`accordion_${result['type']}`);
         }
      }
      if (result !== undefined) {
         window.execute_all(result);
         setMenuActive(result['id'], result['type']);
      }
   }

   const expandMenu = (menuId) => {
      
      if (document.querySelector('.menu.active') != null) {
         document.querySelector('.menu.active').classList.remove('active');
         var accordionContentAll = document.querySelectorAll('.accordionContent');
         for (var i = 0; i <= accordionContentAll.length - 1; i++) {
            accordionContentAll[i].style.height = '0px';
         }
      }

      var accordionContent = document.getElementById(menuId).nextSibling.firstChild;
      if (accordionContent != null) {
         document.getElementById(menuId).classList.add('active')
         document.getElementById(menuId).nextSibling.style.height = accordionContent.offsetHeight + 'px';
      }
   }

   const howToUseMobClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "12";
      document.getElementById('howTousePopup').style.zIndex = "2";
   }


   //code regarding to the rgb functionality

   // ======================   RGB Functionality Code ==========================



function TestChangeTexture2(SCREENCh,count) {
   // console.log(SCREENCh)
   if (window.scene) {

      var mat1 = window.scene._Material_ref["RGB_Rainbow"];
      // console.log(mat1)
      mat1.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);

      // var mat2 = window.scene._Material_ref["RGB_ON"];
      // mat2.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);

      // var mat3 = window.scene._Material_ref["RGB_Rainbow"];
      // mat3.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);

      // var mat4 = window.scene._Material_ref["Alien_HEAD_RGB_mat_copy_copy"];
      // mat4.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);

      window.scene.clearRefine();
   }
}

function TestChangeTexture3(SCREENCh) {
   if (window.scene) {
      var mat4 = window.scene._Material_ref["Alien_HEAD_RGB_mat_copy_copy"];
      mat4.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);
      window.scene.clearRefine();
   }
}

window.stopRGB = ()=>{
   // console.log("off RAINBOW_PLAY");
   window.scene.groupApplyState('RGB_OFF');
   setOnOffBacklit = false;
   if (document.getElementById('onOffkeyBoBacklitAnim')) {
      document.getElementById('onOffkeyBoBacklitAnim').src = window.backlitPlay;
   }
   // window.scene.groupApplyState('RGB_OFF');
   clearInterval(window.screenAnimInterval);
   clearInterval(window.screenAnimInterval1);
   window.animCounter = 1;
   window.animCounter1 = 1;
   window.rainbowCount = 0;
   window._rgb(window.rainbowCount);
}




window.handleRGB = function(){
  
   console.log("onOffkeyBoBacklit",onOffBacklit);    
   if (setOnOffBacklit) {
     

      console.log("off RAINBOW_PLAY");
      window.scene.groupApplyState('RGB_OFF');
      setOnOffBacklit = false;
      if (document.getElementById('onOffkeyBoBacklitAnim')) {
         document.getElementById('onOffkeyBoBacklitAnim').src = window.backlitPlay;
      }
      // window.scene.groupApplyState('RGB_OFF');
      clearInterval(window.screenAnimInterval);
      clearInterval(window.screenAnimInterval1);
      window.animCounter = 1;
      window.animCounter1 = 1;
      window.rainbowCount = 0;
      window._rgb(window.rainbowCount);
   }
   else {
      
      console.log("on RAINBOW_PLAY");
      setOnOffBacklit = true;
      if (document.getElementById('onOffkeyBoBacklitAnim')) {
         document.getElementById('onOffkeyBoBacklitAnim').src = window.backlitPause;
      }
 
      // window.scene.groupApplyState('RGB_Rainbow');
      window.scene.groupApplyState('RGB_ON');
      window.scene.groupApplyState('RGB_Default');
      window.scene.groupApplyState('RGB_Rainbow');

     
      TestChangeTexture2(window.screen[window.animCounter],window.rainbowCount);

      window.screenAnimInterval = setInterval(function () {
         window.animCounter++;
         window.rainbowCount++;
         if (window.animCounter == 8) {
            window.animCounter = 1;
            window.rainbowCount = 0;
         }
         TestChangeTexture2(window.screen[window.animCounter],window.rainbowCount);
         window.scene.clearRefine()
      },1000)


   }
   window.scene.clearRefine();
}

//  window.getElementById("onOffkeyBoBacklit").addEventListener('click',function () {
  
//  })


   const [orentation, setOrentation] = useState(window.innerHeight > window.innerWidth ? 0 : 90)


   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';

   const CanvasResizeFunction = () => {
      if (window.innerHeight > window.innerWidth) {
         setOrentation(0)
      } else if (window.innerWidth > window.innerHeight) {
         setOrentation(90);
      } else {
         setOrentation((item) => {
            return item;
         })
      }
   }
   window.addEventListener('resize', CanvasResizeFunction)

   const { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...uiDataList.ui }
   return (
      <>
         <div className='leftMenuWrapper' id='leftMenuWrapper'>
            <div id='mainMenu' className='menuContainer expanded'>
                {<div className='portraitButton' id={arbuttonName} style={arbuttonName === 'btnXR' ? { 'display': 'block' } : {}}>
                  <span className='portraitButtonText'> {arMob !== undefined ? arMob : 'See the P2425H Monitor in your space'}</span>
               </div>} 
               <div className={`howToUseMob `} id="howToUseMob" onClick={howToUseMobClick} >
                  <span className='portraitButtonText'>{uiDataList.ui?.howToUSE}</span>
               </div>

               <div id="howToUseMenu" tabIndex="-1" className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => { if (e.key !== 'Enter') { return } howToUSEClick() }}>
                  <div className='icon howtouse'> </div>
                  <div className='text'>{howToUSE !== undefined ? howToUSE : 'How to use'}</div>
               </div>
               {orentation === 0 ? <Howtousenew data={uiDataList.ui} /> : <HowToUse data={uiDataList.ui} closeHandle={closeHandleMenu} />}
               <div className={window.mob || (window.isipad && window.innerWidth < window.innerHeight) ? 'accordionContainer relative d-flex' : 'accordionContainer relative '}>
                  {
                     menuList.map((list) => {
                        return (
                           <React.Fragment key={list.id}>
                              {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                 <div id={`btnXR-ipad`} tabIndex="-1" className='menu' key={list.id} >
                                    <div className={`icon ${list.id}`} ></div>
                                    <div className='text'>{list.title} {list.title}</div>
                                 </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="-1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                    if (e.key !== 'Enter') {
                                       return
                                    } accordionMenu(e)
                                 }}>
                                    <>
                                       <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                       <div className={`mob_icon mob_icon_${list.id}`}></div>
                                       <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                       <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path> </svg></div>
                                    </>
                                 </div>
                              }
                              {list.items && list.items.menuVisibility !== "hide" && <SubmenuList subMenuList={list.items} orentation={orentation} handleMenuClick={handleMenuClick} />}
                           </React.Fragment>
                        )
                     })

                  }


               </div>
               <div id="menuFooter">
                  {myJson.QRSupport && <div id="qrCode">
                     <img src='images/qrcode.svg' /> <br />
                     <span className='text'> {QR !== undefined ? QR : 'Scan QR code with your mobile device to view the product in your space'}</span>
                  </div>
                  }
                  <div id="animation">
                     <span>{ReduceTransitions !== undefined ? ReduceTransitions : 'Reduce Transitions'}</span>
                     <label className="switch" tabIndex="1" id="animswtich" onKeyPress={handleTransitionskeyPress} >
                        <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={true} />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff"></span>
                     </label>
                  </div>
                  {ReactDOM.createPortal(
                     <div id="onScreenControl" className='tooltip'>
                        <span className=''>{onScreenControls !== undefined ? onScreenControls : 'On-Screen Controls'}
                           <span className="tooltiptext">{hovertext !== undefined ? hovertext : 'Click to toggle controls on/off'}</span>
                        </span>
                        <label className="switch" tabIndex="-1" id="onScreenControls" onKeyPress={conScreenControlHandlerkeyPress}>
                           <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="onScreenControlsValue" type="checkbox" onChange={conScreenControlHandler} />
                           <span className="tabIndexStyle slider round" ></span>
                           <span className="onOff"></span>
                        </label>
                     </div>, document.getElementById('onScreenControlContainer'))}
               </div>
               <button className='expandColapsBtn' onClick={menuExpandCollaps}></button>
            </div>
            <ColorWrapper  />
            <FooterControl data={uiDataList.ui} onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandleMenu} />
         </div>
      </>
   );
}

export default Menu;